<template>
  <div class="content">
    <div class="container">
      <div class="row m-auto">
        <div class="topic col col-12 col-md-5">
          <Title :title="words.title" />
          <h1>{{ words.topic }}</h1>
        </div>
        <div class="txt col col-12 col-md-7">
          <div class="txt-inside">
            <p>{{ words.content }}</p>
            <!-- <div class="button">
              <Button :msg="words.button"
              :btncolor="btncolor"
              @clickbutton="understandMore"></Button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Button from '@/components/only_button.vue';
import Title from '@/components/title_darkred.vue';

export default {
  props: {
    contentWords: {
      type: Object,
      default: () => ({
        title: 'WHO WE ARE',
        topic: '我們所提供的服務',
        content:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit.Reiciendis mollitia sunt fugiat animi. Repellendus laboriosam et est,totam, consequuntur quaerat tempore temporibus vero qui sequi officiis ad,nam fugiat! Aspernatur!',
        button: '了解我們的服務',
      }),
    },
  },
  data() {
    return {
      words: this.contentWords,
      btncolor: ['whoweare', 'hover-btn'],
    };
  },
  components: {
    // Button,
    Title,
  },
  methods: {
    understandMore() {
      // console.log('點擊這裡就會跳轉到[服務模式]');
      this.$router.push('/services');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content {
  background-color: #efeff0;
  padding: 50px 0;
  .container {
    .row {
      padding: 15px;
      .topic {
        margin-bottom: 20px;
        h1 {
          font-size: 2rem;
          text-align: left;
          margin-top: 30px;
        }
      }
      .txt {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p {
          font-size: 1.2rem;
          text-align: justify;
          margin-bottom: 40px;
        }
        .button {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .content {
    .container {
      .row {
        padding: 0;
        .txt {
          padding: 0;
          p {
            font-size: 1rem;
          }
          .button {
            display: block;
          }
        }
        .topic{
          padding: 0;
        }
      }
    }
  }
}
</style>
